import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tab from "./Tab"
import Style from './Tabs.less'


//const CLASS_ROOT = "tabs";

export default class Tabs extends Component {

    constructor(props, context) {
        super(props, context);

        this._activateTab = this._activateTab.bind(this);

        this.state = {
            activeIndex: props.activeIndex || 0,
            justify: props.justify
        };
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.activeIndex || 0 === nextProps.activeIndex) &&
            this.state.activeIndex !== nextProps.activeIndex) {
            this.setState({ activeIndex: nextProps.activeIndex });
        }
    }

    _activateTab(index) {
        this.setState({ activeIndex: index });
        if (this.props.onActive) {
            this.props.onActive(index);
        }
    }

    getMessage(intl, key, values) {
        if (intl) {
            return intl.formatMessage({
                id: key,
                defaultMessage: key
            }, values);
        } else {
            return key;
        }
    }
    render() {
        const { children, className, justify, responsive, ...props } = this.props;
        delete props.activeIndex;
        delete props.onActive;
        const { activeIndex } = this.state;
        const { intl } = this.context;

        let activeContainer;
        let activeTitle;
        const tabs2 = this.props.children.map((item, index) => {
            if (!item) return null;

            const tabProps = item.props || item._store.props || {};

            const isTabActive = index === activeIndex;

            if (isTabActive) {
                activeContainer = tabProps.children;
                activeTitle = tabProps.title;
            }
            return (
                <Tab title={tabProps.title} active={isTabActive} id={`tab-${index}`} key={`tab-${index}`} onRequestForActive={() => this._activateTab(index)} />
            );
        })
        const tabs = React.Children.map(children, (tab, index) => {
            //console.log('Children')
            //console.log(children)
            //console.log('tab')
            //console.log(tab)
            //const Tab = tab;
            if (!tab) return null;

            const tabProps = tab.props || tab._store.props || {};

            const isTabActive = index === activeIndex;

            if (isTabActive) {
                activeContainer = tabProps.children;
                activeTitle = tabProps.title;
            }
            return (
                <Tab active={isTabActive} id={`tab-${index}`} key={`tab-${index}`} onRequestForActive={() => this._activateTab(index)} />
            );
            /*
            return React.cloneElement(tab, {
                active: isTabActive,
                id: `tab-${index}`,
                onRequestForActive: () => {
                    this._activateTab(index);
                }
            });*/
        }, this);

        const tabContentTitle = this.getMessage(intl, 'Tab Contents', {
            activeTitle: activeTitle
        });
        const styleTabs = { margin: 'halve(24px) 0', padding: '0', display: 'flex', flexWrap: 'wrap', alignItems: 'center', listStyle: 'none', borderBottom: '1px solid rgba(0,0,0,0.15)', justifyContent: 'flex-start' };
        return (
            <div role='tablist'>
                <ul {...props} style={styleTabs}>
                    {tabs2}
                </ul>
                <div aria-label={tabContentTitle} role='tabpanel'>
                    {activeContainer}
                </div>
            </div>
        );
    }
}

Tabs.propTypes = {
    activeIndex: PropTypes.number,
    justify: PropTypes.oneOf(['start', 'center', 'end']),
    responsive: PropTypes.bool,
    onActive: PropTypes.func
};

Tabs.contextTypes = {
    intl: PropTypes.object
};

Tabs.defaultProps = {
    justify: 'center',
    responsive: true
};



// WEBPACK FOOTER //
// ./src/tabs/Tabs.js